module.exports = __webpack_public_path__ + "static/media/zoleLose_1000_2500.a182d356.png";